import { UnitAction, UnitActionType } from "../../Controls/FormParts/Unit/Store/unitActions";
import { UnitId } from "../../Controls/FormParts/Unit/UnitId/UnitId";
import { CandyThunkAction } from "../Core/Store/CandyReduxTypes";

export function scrollToUnitAction(unitId: UnitId): CandyThunkAction {
    return (dispatch, _, form) => {
        dispatch({
            type: UnitActionType.CloseModalUnit,
            payload: {
                targetUnitId: unitId,
            },
        });
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        form.unitNavigator?.scrollToUnit(unitId);
    };
}

export function unitHighlightAction(unitId: UnitId): UnitAction {
    return {
        type: UnitActionType.UnitHighlight,
        payload: {
            unitId: unitId,
        },
    };
}

export function updateEmptyUnits(unitId: UnitId, empty: boolean): UnitAction {
    return {
        type: UnitActionType.UpdateEmptyUnits,
        payload: {
            unitId: unitId,
            empty: empty,
        },
    };
}
